import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  PRIMITIVE,
  ServiceMessageBroker,
  ServiceMessageBrokerFactory,
} from "shared/provider-webworker";

import { BaseLookupService } from "../../../../lookup/impl/BaseLookupService";
import { OrderDataPromiseLookupService } from "../../../../lookup/model/impl/OrderDataPromiseLookupService";
import { InterventionDataPromiseLookupService } from "../../../../lookup/model/impl/InterventionDataPromiseLookupService";
import { BfxBlotterAction } from "../../../../model/contextmenu/bfx-base-blotter/BfxBlotterAction";
import { BfxBlotterOrdersContextMenuAcceptanceItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuAcceptanceItem";
import { BfxBlotterOrdersContextMenuRejectItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuRejectItem";
import { BfxBlotterOrdersContextMenuQuickFillItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuQuickFillItem";
import { BfxBlotterOrdersContextMenuCancelItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuCancelItem";
import { BfxBlotterOrdersContextMenuUnlockItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuUnlockItem";
import { BfxBlotterOrdersContextMenuTransferItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuTransferItem";
import { BfxBlotterOrdersContextMenuTransferAbortItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuTransferAbortItem";
import { BfxBlotterOrdersContextMenuItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuItem";
import { BfxBlotterOrdersContextMenuState } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuState";
import { ContextMenuItem } from "../../../../model/contextmenu/ContextMenuItem";
import { ContextMenuItemState } from "../../../../model/contextmenu/ContextMenuItemState";
import { ContextMenuItemStateCommandCriteria } from "../../../../model/contextmenu/ContextMenuItemStateCommandCriteria";
import { ContextMenuServiceResponse } from "../../../../model/contextmenu/ContextMenuServiceResponse";
import {
  BLOTTER_ORDERS_CONTEXT_MENU_SERVICE,
  IBlotterOrdersContextMenuService,
} from "../IBlotterOrdersContextMenuService";

import { BfxBlotterOrdersContextMenuPromiseService } from "./BfxBlotterOrdersContextMenuPromiseService";
import { BfxBlotterOrdersContextMenuSeparator } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuSeparator";
import { BfxBlotterOrdersContextMenuTakeItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuTakeItem";
import { BfxBlotterOrdersContextMenuForceTakeItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuForceTakeItem";
import { BfxBlotterOrdersContextMenuModifyItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuModifyItem";
import { BfxBlotterOrdersContextMenuDetailFillItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuDetailFillItem";
import { BfxBlotterOrdersContextMenuModifyInfoItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuModifyInfoItem";
import { BfxBlotterOrdersContextMenuDuplicateItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuDuplicateItem";
import { ActiveUser } from "../../../../model/core/ActiveUser";
import { BasePricingService } from "../../../../lookup/pricing/impl/BasePricingService";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { BenchmarkDataPrimaryLookupService } from "shared/cubiq-services/lookup/model/impl/BenchmarkDataPrimaryLookupService";
import { BmarkFixingData } from "shared/cubiq-services/model/benchmarks/BmarkFixingData.model";

import { BfxBlotterOrdersContextMenuFillApproveItem } from "shared/cubiq-services/model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuFillApproveItem";
import { BfxBlotterOrdersContextMenuFillCancelItem } from "shared/cubiq-services/model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuFillCancelItem";
import { OrderPauseState } from "../../../../model/orders/OrderPauseState";
import { BmarkFixingType } from "../../../../model/benchmarks/enums/BmarkFixingType.enum";
import { BfxBlotterOrdersContextMenuInflightCheck } from "shared/cubiq-services/model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuInflightCheck";
import { BfxBlotterOrdersContextMenuPauseItem } from "shared/cubiq-services/model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuPauseItem";
import { BfxBlotterOrdersContextMenuResumeItem } from "shared/cubiq-services/model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuResumeItem";
import { BfxBlotterOrdersContextMenuViewTicketItem } from "shared/cubiq-services/model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuViewTicketItem";
import { BfxBlotterOrdersContextMenuFillNowItem } from "shared/cubiq-services/model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuFillNowItem";

export const PROP_POSTHARDCUTOFF = "pastHardCutoff";
export const ABORTABLE_STATES: CubiqTS.OrderState[] = [
  CubiqTS.OrderState.DI_NEEDED,
  CubiqTS.OrderState.ACCEPTANCE_NEEDED,
  CubiqTS.OrderState.MODIFY_ACCEPTANCE_NEEDED,
];

@Injectable()
export class BfxBlotterOrdersContextMenuPrimaryService extends BfxBlotterOrdersContextMenuPromiseService {
  protected menuItems: Array<BfxBlotterOrdersContextMenuItem>;
  protected broker: ServiceMessageBroker;

  constructor(
    protected factory: ServiceMessageBrokerFactory,
    protected orderDataService: OrderDataPromiseLookupService,
    protected bmOrderDataService: BenchmarkDataPrimaryLookupService,
    protected interventionDataService: InterventionDataPromiseLookupService,
    protected pricing: BasePricingService,
  ) {
    super();
    this.broker = this.factory.createMessageBroker(BLOTTER_ORDERS_CONTEXT_MENU_SERVICE, true, true);

    this.broker.registerMethod(
      "getMenuItems",
      [PRIMITIVE, PRIMITIVE],
      this.getMenuItems.bind(this),
      PRIMITIVE,
    );

    let acceptanceMenuItemFactory = new BfxBlotterOrdersContextMenuAcceptanceItem.Factory();
    let rejectMenuItemFactory = new BfxBlotterOrdersContextMenuRejectItem.Factory();

    this.menuItems = [
      new BfxBlotterOrdersContextMenuFillApproveItem(),
      new BfxBlotterOrdersContextMenuFillCancelItem(),

      acceptanceMenuItemFactory.AcceptOrAcceptTopside(),
      acceptanceMenuItemFactory.OptionalAcceptDownside(),
      acceptanceMenuItemFactory.AcceptInto(),
      rejectMenuItemFactory.Reject(),

      new BfxBlotterOrdersContextMenuSeparator(),

      new BfxBlotterOrdersContextMenuQuickFillItem(),
      new BfxBlotterOrdersContextMenuDetailFillItem(),
      new BfxBlotterOrdersContextMenuItem(
        BfxBlotterAction.ACTION_ORDER_REACTIVATE,
        "Re-Activate",
        function checkAvailable(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
        ) {
          itemState.available = menuState.canReactivateOrders;
        },
        function checkEnabled(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
          item: CubiqTS.OrderDataImpl,
        ) {
          // Cannot Reactivate MKT Orders
          if (item && item.requestedOrderType === CubiqTS.RequestOrderType.MARKET) {
            // NOP
          } else if (
            item &&
            (CubiqTS.OrderState.MANUAL_PRICING == item.orderState ||
              CubiqTS.OrderState.TRIGGERED == item.orderState ||
              CubiqTS.OrderState.FILLING == item.orderState) &&
            item.lockType === undefined
          ) {
            if (
              menuState.activeUser.userTypeId === CubiqTS.UserType.ADMIN ||
              (item.deskId != null &&
                menuState.activeUser.userTypeId === CubiqTS.UserType.TRADER &&
                menuState.activeUser.tradingGroupsIdSet.has(item.deskId.toString())) ||
              (menuState.activeUser.userTypeId === CubiqTS.UserType.SALES &&
                menuState.activeUser.salesGroupsIdSet.has(item.salesGroupId.toString())) ||
              (menuState.activeUser.userTypeId === CubiqTS.UserType.CLIENT &&
                menuState.activeUser.clientIdSet.has(item.clientCode))
            ) {
              // Trader: owned by a Trader Group !'m a member of
              // Sales: client of a Sales Group I'm a member of
              // Admin: any
              // Client: for my clients
              itemState.count++;
            }
          }
          itemState.enabled = itemState.count > 0; // menuState.count === itemState.count;
        },
      ),

      new BfxBlotterOrdersContextMenuSeparator(),

      new BfxBlotterOrdersContextMenuModifyItem(), // Modify
      new BfxBlotterOrdersContextMenuModifyInfoItem(), // Modify Info
      new BfxBlotterOrdersContextMenuCancelItem(),
      new BfxBlotterOrdersContextMenuDuplicateItem(), // Duplicate
      new BfxBlotterOrdersContextMenuUnlockItem(),
      new BfxBlotterOrdersContextMenuItem(
        BfxBlotterAction.ACTION_ORDER_ABORT,
        "Abort",
        function checkAvailable(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
        ) {
          itemState.available = true;
        },
        function checkEnabled(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
          item: CubiqTS.OrderDataImpl,
        ) {
          let enabled: boolean = false;
          let abortOwnModify =
            (item.modifyInAcceptanceFg ||
              item.orderState !== CubiqTS.OrderState.ACCEPTANCE_NEEDED) &&
            CubiqTS.Long.isLong(item.lockUserId) &&
            item.lockUserId.toString() === menuState.activeUser.userId;
          let abortOwnEntry =
            !item.modifyInAcceptanceFg &&
            item.orderState === CubiqTS.OrderState.ACCEPTANCE_NEEDED &&
            item.entryUserCode === menuState.activeUser.userCode;

          try {
            if (
              menuState.count === 1 &&
              item != null &&
              menuState?.activeUser != null &&
              ABORTABLE_STATES.includes(item.orderState) &&
              (abortOwnModify || abortOwnEntry)
            ) {
              enabled = true;
            }
          } catch (e) {
            logger.out.warn(
              `BfxBlotterOrdersContextMenuPrimaryService: ` +
                `Failed to check abort menu state ${e}`,
            );
          }

          itemState.enabled = enabled;
        },
      ),

      new BfxBlotterOrdersContextMenuSeparator(),

      new BfxBlotterOrdersContextMenuTransferItem(),
      new BfxBlotterOrdersContextMenuTakeItem(),
      new BfxBlotterOrdersContextMenuForceTakeItem(),
      new BfxBlotterOrdersContextMenuTransferAbortItem(),

      new BfxBlotterOrdersContextMenuSeparator(),

      new BfxBlotterOrdersContextMenuPauseItem(),
      new BfxBlotterOrdersContextMenuResumeItem(),

      new BfxBlotterOrdersContextMenuSeparator(),
      new BfxBlotterOrdersContextMenuFillNowItem(),

      // Inflight check items
      new BfxBlotterOrdersContextMenuSeparator(),
      new BfxBlotterOrdersContextMenuInflightCheck(
        BfxBlotterAction.ACTION_ORDER_DISABLE_INFLIGHT,
        "Disable Inflight Checks",
        CubiqTS.InflightInclusionState.ENABLED,
      ),

      new BfxBlotterOrdersContextMenuInflightCheck(
        BfxBlotterAction.ACTION_ORDER_ENABLE_INFLIGHT,
        "Enable Inflight Checks",
        CubiqTS.InflightInclusionState.DISABLED,
      ),
      new BfxBlotterOrdersContextMenuSeparator(),

      new BfxBlotterOrdersContextMenuViewTicketItem(),
      new BfxBlotterOrdersContextMenuItem(
        BfxBlotterAction.ACTION_VIEW_DETAILS,
        "View Details",
        function checkAvailable(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
        ) {
          itemState.available = true;
        },
        function checkEnabled(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
        ) {
          itemState.enabled = menuState.count == 1;
        },
        ContextMenuItemStateCommandCriteria.MenuItem,
        ContextMenuItemStateCommandCriteria.MenuItem,
      ),
      new BfxBlotterOrdersContextMenuItem(
        BfxBlotterAction.ACTION_VIEW_AUDIT,
        "View Audit Log",
        function checkAvailable(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
        ) {
          itemState.available = true;
        },
        function checkEnabled(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
        ) {
          itemState.enabled = menuState.count == 1;
        },
        ContextMenuItemStateCommandCriteria.MenuItem,
        ContextMenuItemStateCommandCriteria.MenuItem,
      ),
      new BfxBlotterOrdersContextMenuItem(
        BfxBlotterAction.ACTION_ORDER_RECAP,
        "Order Recap",
        function checkAvailable(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
        ) {
          itemState.available = menuState.canExport;
        },
        function checkEnabled(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
        ) {
          itemState.enabled = menuState.count > 0;
        },
        ContextMenuItemStateCommandCriteria.MenuItem,
        ContextMenuItemStateCommandCriteria.MenuItem,
      ),
      new BfxBlotterOrdersContextMenuItem(
        BfxBlotterAction.ACTION_EXPORT,
        "Export to CSV",
        function checkAvailable(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
        ) {
          itemState.available = menuState.canExport;
        },
        function checkEnabled(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
        ) {
          itemState.enabled = menuState.count > 0;
        },
        ContextMenuItemStateCommandCriteria.MenuItem,
        ContextMenuItemStateCommandCriteria.MenuItem,
      ),
      new BfxBlotterOrdersContextMenuItem(
        BfxBlotterAction.ACTION_EXPORT_IMPORT,
        "Export for Import",
        function checkAvailable(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
        ) {
          itemState.available = menuState.canExportForImport;
        },
        function checkEnabled(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
        ) {
          itemState.enabled = menuState.count > 0;
        },
        ContextMenuItemStateCommandCriteria.MenuItem,
        ContextMenuItemStateCommandCriteria.MenuItem,
      ),
    ];
  }

  protected getActionDecorators(items: Array<any>): any {
    // nothing to add
  }

  public getMenuItems(
    selectedIds: Array<string>,
    menuState: BfxBlotterOrdersContextMenuState,
  ): Promise<ContextMenuServiceResponse<CubiqTS.OrderDataImpl, BfxBlotterOrdersContextMenuItem>> {
    return new Promise((resolve, reject) => {
      let base = this.orderDataService.getBase() as BaseLookupService<
        string,
        CubiqTS.OrderDataImpl
      >;
      let interventionBase = this.interventionDataService.getBase() as BaseLookupService<
        string,
        CubiqTS.InterventionEventImpl
      >;

      menuState = Object.assign(new BfxBlotterOrdersContextMenuState(), menuState);
      menuState.activeUser = Object.assign(new ActiveUser(), menuState.activeUser);
      menuState.pricingService = this.pricing;
      menuState.reset();

      let menuItems: Array<BfxBlotterOrdersContextMenuItem>;
      menuState.count = selectedIds.length;

      menuItems = this.menuItems.map<BfxBlotterOrdersContextMenuItem>(
        (menuItem, menuItemIndex, menuItems) => {
          menuItem.reset();

          if (ContextMenuItemStateCommandCriteria.MenuItem === menuItem.checkAvailableCriteria) {
            menuItem.checkAvailable(menuState, menuItem.state, null);
          }

          if (ContextMenuItemStateCommandCriteria.MenuItem === menuItem.checkEnabledCriteria) {
            menuItem.checkEnabled(menuState, menuItem.state, null);
          }

          return menuItem;
        },
      );

      let itemIndex = 0;
      selectedIds.forEach((id, i) => {
        let item = base.getItem(id);

        if (!item && menuState["selectedDIEventIds"]) {
          item = interventionBase.getItem(menuState["selectedDIEventIds"][i])
            .orderData as CubiqTS.OrderDataImpl;
        }

        if (!item && this.bmOrderDataService.hasBmarkOrderDataForOrderId(id)) {
          this.bmOrderDataService.getBmarkOrderDataForOrderIds([id]).then((found) => {
            if (found && found.length > 0) {
              item = found[0];
              let fixingId = BmarkFixingData.id(
                item.fixingSourceCd,
                item.fixingDate,
                BmarkFixingType.ACTIVE,
              );
              // try active fixings - recent fixings have passed so orders should not be editable
              let activeFixingData: BmarkFixingData =
                this.bmOrderDataService.getActiveFixingData(fixingId);

              let pastHardCutoff: boolean = false;
              if (activeFixingData != null) {
                pastHardCutoff = activeFixingData.state === CubiqTS.FixingState.HARD_CUTOFF;
              } else {
                pastHardCutoff = true; // recent fixings
              }
              if (pastHardCutoff)
                item.extendedInfo.set(PROP_POSTHARDCUTOFF, pastHardCutoff.toString());
            }
            menuItems.forEach((menuItem, menuItemIndex) => {
              menuState.menuItemIndex = menuItemIndex;

              if (ContextMenuItemStateCommandCriteria.Item === menuItem.checkAvailableCriteria) {
                menuItem.checkAvailable(menuState, menuItem.state, item, itemIndex);
              }

              if (ContextMenuItemStateCommandCriteria.Item === menuItem.checkEnabledCriteria) {
                menuItem.checkEnabled(menuState, menuItem.state, item, itemIndex);
              }
            });
            menuState.itemIndex = itemIndex;
            itemIndex++;
          });
        } else {
          menuItems.forEach((menuItem, menuItemIndex) => {
            menuState.menuItemIndex = menuItemIndex;

            if (ContextMenuItemStateCommandCriteria.Item === menuItem.checkAvailableCriteria) {
              menuItem.checkAvailable(menuState, menuItem.state, item, itemIndex);
            }

            if (ContextMenuItemStateCommandCriteria.Item === menuItem.checkEnabledCriteria) {
              menuItem.checkEnabled(menuState, menuItem.state, item, itemIndex);
            }
          });

          menuState.itemIndex = itemIndex;
          itemIndex++;
        }
      });

      menuItems.forEach((menuItem, menuItemIndex) => {
        menuState.menuItemIndex = menuItemIndex;

        if (ContextMenuItemStateCommandCriteria.PostItem === menuItem.checkAvailableCriteria) {
          menuItem.checkAvailable(menuState, menuItem.state);
        }

        if (ContextMenuItemStateCommandCriteria.PostItem === menuItem.checkEnabledCriteria) {
          menuItem.checkEnabled(menuState, menuItem.state);
        }

        //
        //   menuItem.checkAvailable = null;
        //   menuItem.checkEnabled = null;
      });
      menuState.pricingService = null;

      resolve({
        menuItems: menuItems,
        menuState: menuState,
        actionDecorators: null,
      });
    });
  }

  public getMenuItemsForDataItem(
    item: CubiqTS.OrderDataImpl,
    menuState: BfxBlotterOrdersContextMenuState,
  ): ContextMenuServiceResponse<CubiqTS.OrderDataImpl, BfxBlotterOrdersContextMenuItem> {
    menuState = Object.assign(new BfxBlotterOrdersContextMenuState(), menuState);
    menuState.activeUser = Object.assign(new ActiveUser(), menuState.activeUser);
    menuState.pricingService = this.pricing;
    menuState.reset();

    let menuItems: Array<BfxBlotterOrdersContextMenuItem>;
    menuState.count = 1;

    let itemIndex = 0;

    menuItems = this.menuItems.map<BfxBlotterOrdersContextMenuItem>(
      (menuItem, menuItemIndex, menuItems) => {
        menuItem.reset();
        if (ContextMenuItemStateCommandCriteria.MenuItem === menuItem.checkAvailableCriteria) {
          menuItem.checkAvailable(menuState, menuItem.state, null);
        }
        if (ContextMenuItemStateCommandCriteria.MenuItem === menuItem.checkEnabledCriteria) {
          menuItem.checkEnabled(menuState, menuItem.state, null);
        }
        return menuItem;
      },
    );

    menuItems.forEach((menuItem, menuItemIndex) => {
      menuState.menuItemIndex = menuItemIndex;
      if (ContextMenuItemStateCommandCriteria.Item === menuItem.checkAvailableCriteria) {
        menuItem.checkAvailable(menuState, menuItem.state, item, itemIndex);
      }
      if (ContextMenuItemStateCommandCriteria.Item === menuItem.checkEnabledCriteria) {
        menuItem.checkEnabled(menuState, menuItem.state, item, itemIndex);
      }
    });

    menuItems.forEach((menuItem, menuItemIndex) => {
      menuState.menuItemIndex = menuItemIndex;

      if (ContextMenuItemStateCommandCriteria.PostItem === menuItem.checkAvailableCriteria) {
        menuItem.checkAvailable(menuState, menuItem.state);
      }
      if (ContextMenuItemStateCommandCriteria.PostItem === menuItem.checkEnabledCriteria) {
        menuItem.checkEnabled(menuState, menuItem.state);
      }
    });
    return {
      menuItems: menuItems,
      menuState: menuState,
      actionDecorators: null,
    };
  }
}
